<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.phases'), $t('text.list')]">
        <el-button type="success" size="mini" @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />

    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="phaseTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column width="60px">
          <template v-slot="{ row, rowIndex }">
            <i
              v-if="rowIndex != 0"
              class="el-icon-top mgr10"
              @click="swapSequence(row, rowIndex, 'up')"
            ></i>
            <i
              v-if="
                rowIndex + 1 !=
                (pager.pageSize > pager.total ? pager.total : pager.pageSize)
              "
              class="el-icon-bottom"
              @click="swapSequence(row, rowIndex, 'down')"
            ></i>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="sequence"
          :title="$t('text.sequence')"
          width="100px"
        />
        <vxe-table-column field="name" :title="$t('text.name')" />
        <vxe-table-column
          field="phaseGroupName"
          :title="$t('menu.phaseGroups')"
        />
        <vxe-table-column
          field="ownFactoryStr"
          :title="'所在' + $t('menu.factories')"
        />

        <vxe-table-column field="action" :title="$t('text.action')" width="100">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="edit(row)">{{
              $t("text.edit")
            }}</el-button>
            <el-button type="text" size="mini" @click="deleteRow(row)">{{
              $t("text.delete")
            }}</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="40%"
    >
      <el-form ref="addObjForm" :model="addObj">
        <div v-for="(item, index) in addObj.items" :key="index">
          <el-row :gutter="5">
            <el-col :span="8">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="item.name"
                  :placeholder="$t('text.name')"
                  @blur="existJudge(index)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item>
                <el-select
                  size="small"
                  v-model="item.phaseGroupId"
                  filterable
                  clearable
                  :placeholder="$t('menu.phaseGroups')"
                >
                  <el-option
                    v-for="phaseGroup in phaseGroups"
                    :key="phaseGroup.id"
                    :label="phaseGroup.name"
                    :value="phaseGroup.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="item._factoryPrices.length != 0" :span="4">
              <el-form-item>
                <span class="font10 blue" @click="showPhasePrice(index)">
                  {{ $t("factory.setPhasePrice") }}
                </span>
              </el-form-item>
            </el-col>
            <el-col v-if="item._invExist || item._localRepeat" :span="4">
              <el-form-item>
                <small v-if="item._invExist" class="red">{{
                  $t("rules.exist", [$t("text.name")])
                }}</small>
                <small v-if="item._localRepeat" class="red">{{
                  $t("rules.filledIn", [$t("text.name")])
                }}</small>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item>
                <i
                  v-if="index"
                  class="el-icon-delete red"
                  @click="remove(index)"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="item._showPhasePriceDF" :gutter="10">
            <el-col
              v-for="fp of item._factoryPrices"
              :key="fp.id"
              :span="8"
              class="mgb5"
            >
              <el-input v-model="fp.phasePrice" size="mini">
                <template slot="prepend">
                  <raw-html-limit-number
                    :content="fp.factoryName"
                    :number="6"
                  />
                </template>
              </el-input>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row>
            <el-col :span="20">
              <el-button
                type="success"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="addMore"
                >{{ $t("text.more") }}</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="saveDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="70px">
        <el-form-item
          :label="$t('text.sequence')"
          :prop="'sequence'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.sequence')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.sequence"
            :placeholder="$t('text.sequence')"
          />
        </el-form-item>
        <el-form-item
          :label="$t('text.name')"
          :prop="'name'"
          :rules="[
            {
              required: true,
              validator: validateNameEdit,
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editObj.name"
            :placeholder="$t('text.name')"
          />
        </el-form-item>
        <el-form-item :prop="'phaseGroupId'" :label="$t('menu.phaseGroups')">
          <el-select
            size="small"
            v-model="editObj.phaseGroupId"
            filterable
            clearable
          >
            <el-option
              v-for="phaseGroup in phaseGroups"
              :key="phaseGroup.id"
              :label="phaseGroup.name"
              :value="phaseGroup.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils";
import PhaseGroup from "@/api/phaseGroup.js";
import Phase from "@/api/phase.js";
import Factory from "@/api/factory.js";

function build() {
  return {
    name: null,
    phaseGroupId: null,
    _invExist: false,
    _localRepeat: false,
    _showPhasePriceDF: false,
    _factoryPrices: [],
    factoryPhases: [],
  };
}
export default {
  mixins: [page, table.pager, table.narrow, table.basic],
  components: {},
  data() {
    var validateNameEdit = (rule, value, callback) => {
      const self = this;
      if (value == null || value == "") {
        callback(new Error(self.$t("rules.required", [self.$t("text.name")])));
        return;
      }
      if (
        self.phases.filter((s) => s.name == value).length > 0 &&
        value !== self.row.name
      ) {
        callback(new Error(self.$t("rules.exist", [this.$t("text.name")])));
        return;
      } else {
        callback();
      }
    };
    return {
      phases: [],
      phaseGroups: [],
      factories: [],
      narrows: [],
      // 新增
      addDF: false,
      addObj: {
        items: [],
      },
      saveDoing: false,
      // 编辑
      validateNameEdit: validateNameEdit,
      editDF: false,
      row: null,
      editObj: {
        name: null,
        phaseGroupId: null,
        sequence: null,
      },
      editDoing: false,
    };
  },
  created() {
    const self = this;
    self.loadingStart();
    PhaseGroup.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.phaseGroups = res.data;
        if (self.phaseGroups.length !== 0) {
          self.narrows.push([
            {
              label: self.$t("menu.phaseGroups"),
              items: self.phaseGroups.map((phaseGroup) => {
                return {
                  label: phaseGroup.name,
                  key: phaseGroup.id,
                  condition: { phaseGroupId: phaseGroup.id },
                };
              }),
            },
          ]);
        }
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {
    swapSequence(row, rowIndex, type) {
      const self = this;
      const obj = {
        swapId: row.id,
        swapId2:
          type == "up"
            ? self.records[rowIndex - 1].id
            : self.records[rowIndex + 1].id,
      };
      Phase.swapSequence(obj).then(function (res) {
        if (res.status == 200) {
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (
        confirm(
          self.$t("prompt.confirmDelete") +
            "\u000d删除工序后，产品工序配置、工人工序配置、工厂工序配置  、工人工序配置 中的此工序也会删除"
        )
      ) {
        Phase.delete(row.id).then(function (res) {
          if (res.status === 200) {
            if (res.data.type === "fail") {
              self.$message({
                message: res.data.message,
                type: "warning",
              });
            } else {
              self.$message({
                message: self.$t("prompt.delSuccess"),
                type: "success",
              });
            }

            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row) {
      const self = this;
      self.row = row;
      self.editObj.name = row.name;
      self.editObj.phaseGroupId = row.phaseGroupId;
      self.editObj.sequence = row.sequence;
      self.editDoing = false;
      Phase.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.phases = res.data;
          self.editDF = true;
        } else {
          self.sysError();
        }
      });
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          Phase.update(self.row.id, self.editObj).then(function (res) {
            if (res.status === 200) {
              self.editDoing = false;
              self.editDF = false;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增
    add() {
      const self = this;
      axios.all([Phase.findByTenantId(), Factory.findByTenantId()]).then(
        axios.spread(function (phases, factories) {
          if (phases.status === 200) {
            self.phases = phases.data;
          } else {
            self.sysError();
          }
          if (factories.status === 200) {
            self.factories = factories.data;
            self.addObj.items = [build(), build(), build()];
            for (const item of self.addObj.items) {
              item._factoryPrices = self.factories.map((f) => {
                return {
                  factoryId: f.id,
                  factoryName: f.name,
                  phasePrice: 1,
                };
              });
            }
            self.addDF = true;
          } else {
            self.sysError();
          }
        })
      );
    },
    showPhasePrice(idx) {
      if (this.addObj.items[idx]._factoryPrices.length == 0) {
        this.$message({
          message: "暂无设置产线",
          type: "warning",
        });
        return;
      }
      this.addObj.items[idx]._showPhasePriceDF =
        !this.addObj.items[idx]._showPhasePriceDF;
    },
    remove(idx) {
      this.addObj.items.splice(idx, 1);
    },
    addMore() {
      const newBuild = build();
      newBuild._factoryPrices = this.factories.map((f) => {
        return { factoryId: f.id, factoryName: f.name, phasePrice: 1 };
      });
      this.addObj.items.push(newBuild);
    },
    existJudge(idx) {
      const self = this;
      self.addObj.items[idx]._invExist = false;
      self.addObj.items[idx]._localRepeat = false;
      if (
        self.addObj.items[idx].name != null &&
        self.addObj.items[idx].name !== ""
      ) {
        const itemNames = self.phases.map((s) => s.name);
        if (itemNames.includes(self.addObj.items[idx].name)) {
          this.addObj.items[idx]._invExist = true;
          return;
        }
        // 本地过滤
        const iis = self.addObj.items.filter(function (s) {
          return s.name === self.addObj.items[idx].name;
        });
        if (iis.length > 1) {
          this.addObj.items[idx]._localRepeat = true;
        }
      }
    },

    addSubmit() {
      const self = this;
      const items = JSON.parse(JSON.stringify(this.addObj.items)).filter(
        function (item) {
          return item.name !== null && item.name !== "";
        }
      );
      if (items.length === 0) {
        self.$message({
          message: this.$t("prompt.atLeastOneValidDataFillIn"),
          type: "warning",
        });
        return;
      }

      for (const item of items) {
        if (item._invExist === true || item._localRepeat === true) {
          self.$message({
            message: this.$t("prompt.errorMessage"),
            type: "warning",
          });
          return;
        }
        const factoryPricesFilter = JSON.parse(
          JSON.stringify(item._factoryPrices)
        ).filter((fp) => fp.phasePrice !== null || fp.phasePrice !== "");
        if (factoryPricesFilter.length != 0) {
          for (const fp of factoryPricesFilter) {
            if (!Util.regexPrice(fp.phasePrice)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("product.price")]),
                type: "warning",
              });
              return;
            }
          }
        }
        item.factoryPhases = factoryPricesFilter;
      }
      self.saveDoing = true;
      Phase.insertBatch(items).then(function (res) {
        self.saveDoing = false;
        self.addDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    dataProvider(params) {
      return Phase.search(params);
    },
  },
};
</script>
<style scoped>
</style>